import { StatusView } from "./StatusView";

export const styles = {
  container: {
    background: "#ffffff",
    overflowX: "auto",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
  },

  th: {
    textAlign: "left",
    padding: "12px",
    color: "#705ed4",
    borderBottom: "2px solid #f1f1f1",
    fontWeight: "600",
    fontSize: "14px",
  },

  td: {
    padding: "12px",
    borderBottom: "1px solid #f5f5f5",
    fontSize: "14px",
    color: "#333",
  },

  tr: {
    transition: "all 0.2s ease",
  },

  status: {
    padding: "4px 10px",
    borderRadius: "999px",
    fontSize: "12px",
    fontWeight: "500",
    textTransform:"capitalize"
  },
  completed: {
    background: "#f3e8ff",
    color: "#705ed4",
  },
  incomplete:{
    background:"#d1d1d140",
    color:"grey"
  }
};

export function List({ children, loading, error, message, className="" }) {
  return (
    <div className={className}>
      <StatusView loading={loading} error={error} message={message} />
      {!error && !loading ? children : null}
    </div>
  );
}
